import CodeMirrorInput from "./CodeMirrorInput";
import UploadFormChild from "./UploadExcel";
import { Dropdown, Input, MenuProps, Form, Radio, RadioChangeEvent } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import './index.less'

export default function BatchImportAmount({ form }: any) {
  const { t } = useTranslation()
  const [opType, setOpType] = useState('simple')
  const [mode, setMode] = useState(1);
  const [isUploadFileSuccess, setIsUploadFileSuccess] = useState(false)

  const FormAddrsChild = (props: any) => {

    function onDone(value: any = '') {
      form.setFieldValue('amounts', value)
      setMode(1)
    }

    function onError(bol: any = false) {
      setIsUploadFileSuccess(bol)
    }

    function onInputCode(value: any) {
      const trimmedValue = value.replace(/ /g, ''); // 去掉所有空格
      // console.log(trimmedValue, 'value 123123');
      // setFormAddresses(trimmedValue);
      form.setFieldValue('amounts', trimmedValue);
    }

    const { t } = useTranslation()
    const placeholder = `${t("components.amountTips")}\n1.234\n123`

    return (
      <div>
        <Input {...props} type={'hidden'} />
        {
          mode === 2 ? <UploadFormChild onDone={onDone} /> : <CodeMirrorInput placeholder={placeholder} code={form.getFieldValue('amounts')} onInputCode={onInputCode} onError={onError} />
        }
      </div>
    )
  }
  const options = [
    { label: t("components.manualInput"), value: 1 },
    { label: t("components.uploadFile"), value: 2 }
  ];

  const onChangeMode = ({ target: { value } }: RadioChangeEvent) => {
    console.log('radio3 checked', value);
    setMode(value);
  }

  return (<div className="batch-import-amounts">
    <div className='addrs-head'>
      <div className='title'></div>
      <Radio.Group options={options} onChange={onChangeMode} value={mode} optionType="button" className='option-mode' />
    </div>
    <Form.Item
      label=""
      name={"amounts"}
      rules={[{ required: true, message: t("components.enterAmount") }]}
    >
      <FormAddrsChild />
    </Form.Item>
  </div>)
}